export default {"src":"/_next/static/media/phone-call.dc7ef558.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};